import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Users } from 'lucide-react';
import { tipoLabel } from '../utils/tipi';
import { servizioPath } from '../utils/slug';
import { formatPrezzo } from '../utils/prezzo';
import './ServiceCard.css';

function ServiceCard({ servizio }) {
  const imageUrl = servizio.prima_foto || 'https://via.placeholder.com/300x200?text=Location';
  const badgeColor = servizio.tipo;
  const prezzo = formatPrezzo(servizio);

  return (
    <Link to={servizioPath(servizio)} className="service-card-link">
      <div className="service-card">
        {/* Image */}
        <div className="card-image-container">
          <img
            src={imageUrl}
            alt={servizio.nome}
            className="card-image"
          />
          <div className={`card-badge badge-${badgeColor}`}>
            {tipoLabel(servizio.tipo)}
          </div>
        </div>

        {/* Content */}
        <div className="card-content">
          <h3 className="card-title">{servizio.nome}</h3>

          {/* Location info */}
          {servizio.citta && (
            <div className="card-location">
              <MapPin size={14} />
              <span>{servizio.citta}</span>
            </div>
          )}

          {/* Price range */}
          <div className="card-price">{prezzo}</div>

          {/* Age range */}
          {(servizio.eta_minima || servizio.eta_massima) && (
            <div className="card-details">
              <div className="detail-item">
                <Users size={14} />
                <span>{servizio.eta_minima ?? 0}-{servizio.eta_massima ?? 18} anni</span>
              </div>
            </div>
          )}

          {/* Indoor/Outdoor badge */}
          {servizio.indoor_outdoor && (
            <div className="card-meta">
              <span className="meta-badge">
                {servizio.indoor_outdoor === 'indoor' ? 'Al chiuso' : servizio.indoor_outdoor === 'outdoor' ? 'All\'aperto' : 'Interno + esterno'}
              </span>
            </div>
          )}

          {/* Provider name */}
          {servizio.nome_attivita && (
            <div className="card-provider">{servizio.nome_attivita}</div>
          )}
        </div>
      </div>
    </Link>
  );
}

export default ServiceCard;
